/**
 * Contact Service
 *
 * Handles contact form API calls
 */

import api from './api';

export const contactService = {
  /**
   * Submit contact form
   * @param {Object} contactData - Contact form data
   * @param {string} contactData.name - Full name (2-100 characters)
   * @param {string} contactData.email - Email address
   * @param {string} contactData.subject - Subject (5-200 characters)
   * @param {string} contactData.message - Message (10-5000 characters)
   * @returns {Promise<Object>} API response
   */
  submitContact: async (contactData) => {
    try {
      const response = await api.post('/contact', contactData);
      return response.data;
    } catch (error) {
      console.error('[ContactService] Submit contact error:', error);
      throw error;
    }
  }
};

export default contactService;
